import Icons from 'Common/Icons'
import React from 'react'
import PhotoSkeleton from './PhotoSkeleton'
import "./Styles/AvatarGroup.scss";

function DoctorPatientAvatar(props) {
  return (
    <div className='avatar-grouped-container'>
        <div className={`${props?.size == "40_&_28"? "doc-avatar-img-container-40" :"doc-avatar-img-container-56"}`}>
            <PhotoSkeleton src={props?.doc_img}>
                <img src={props?.doc_img ? props?.doc_img : Icons.doctor_default}/>
            </PhotoSkeleton>
        </div>
        <div className={`${props?.size == "40_&_28"? "patient-avatar-img-container-28" :"patient-avatar-img-container-36"}`}>
            <PhotoSkeleton src={props?.patient_img}>
                <img src={props?.patient_img ? props?.patient_img : Icons.patient_default}/>
            </PhotoSkeleton>
        </div>        
    </div>
  )
}

export default DoctorPatientAvatar
